<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :disabledSave="disabled"
        :icon="icon" 
        v-bind:show.sync="dialog"
        maxWidth="50%"
        textButtonSave="Salvar Cenário"
    >
        <template v-slot:form>
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <s-text-field 
                                autofocus dense 
                                :error-messages="errors.name" 
                                v-model="localModel.name" 
                                label="Nome*"
                            />
                        </v-col>
                        <!-- <v-col cols="12" sm="3">
                            <sys-select-dynamic-attribution-type
                                :model.sync="localModel.dynamic_attribution_type_id"
                                :error="errors.length > 0"  
                                :errors="errors.dynamic_attribution_type_id"
                                label="Tipo"
                                dense
                            />
                        </v-col> -->
                        <v-col cols="12" sm="8">
                            <sys-select-shift
                                :model.sync="localModel.shifts"
                                :error="errors.length > 0"  
                                :errors="errors.shifts"
                                label="Turno*"
                                dense
                                multiple
                                select-all
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <sys-select-campus
                                :model.sync="localModel.campuses"
                                :error="errors.length > 0"  
                                :errors="errors.campuses"
                                label="Campus*"
                                multiple
                                dense
                                select-all
                                only-active
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <sys-select-course
                                :model.sync="localModel.courses"
                                :error="errors.length > 0"  
                                :errors="errors.courses"
                                label="Curso"
                                multiple
                                dense
                                select-all
                                only-active
                                :shifts="localModel.shifts"
                                :campus-id="localModel.campuses ?  localModel.campuses.map(c => c.id).join(',') : null"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="localModel.join_between_campuses" 
                                text-helper='Considerar junção entre campus diferentes' 
                                inset 
                                label="Junção entre campus"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="localModel.join_only_digital" 
                                text-helper='Considerar apenas as ofertas com tipo de carga horária digital' 
                                inset 
                                label="Somente disciplina digital"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="localModel.only_grid_not_join" 
                                text-helper='Considerar apenas as ofertas que não possuem junção cadastrada' 
                                inset 
                                label="Grades sem Junção"
                                :disabled="false"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="localModel.consider_students_forecast" 
                                text-helper='Considerar previsão de alunos ao invés do número de alunos confirmados' 
                                inset 
                                label="Previsão de Alunos"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="localModel.consider_course_cluster" 
                                text-helper='Realizar junção entre cursos do mesmo cluster' 
                                inset 
                                label="Cluster de Cursos"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="localModel.equalize_students" 
                                text-helper='Equalizar número de alunos' 
                                inset 
                                label="Equalizar alunos"
                                disabled
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" sm="4">
                             <v-select
                                v-model="localModel.join_type"
                                :items="joinTypes"
                                label="Tipo de Junção"
                                item-value="id"
                                item-text="name"
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <sys-select-dynamic-division-type
                                :model.sync="localModel.dynamic_division_type_id"
                                :error="errors.length > 0"  
                                :errors="errors.dynamic_division_type_id"
                                label="Origem Limite de Alunos"
                                dense
                                show-description
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                             <v-select
                                v-model="localModel.calculation_type_capacity"
                                :items="calculationTypes"
                                label="Cálculo da Capacidade"
                                item-value="id"
                                item-text="name"
                                dense
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="4">
                            <s-text-field
                                v-model="localModel.limit_classroom" 
                                :error-messages="errors.limit_classroom" 
                                label="Limite Teórica*"
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-text-field
                                v-model="localModel.limit_practice" 
                                :error-messages="errors.limit_practice" 
                                label="Limite Prática*"
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-text-field
                                v-model="localModel.limit_digital" 
                                :error-messages="errors.limit_digital" 
                                label="Limite Digital*"
                            />
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterDynamicJoinRegister",
    data: (vm) => ({
        dialog: false,
        localModel: {},
        error: false,
        errors: {},
        message: '',
        loading: false,
        disabled: false,
        joinTypes: [
            { id: 'group', name: 'Turma' },
            { id: 'discipline', name: 'Disciplina' },
        ],
        calculationTypes: [
            { id: 'avg', name: 'Média' },
            { id: 'min', name: 'Mínimo' },
            { id: 'max', name: 'Máximo' },
        ]
    }),
    created() {
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                
                this.error = false;
                this.errors = {};
                this.disabled = false;
                
                if(!this.model.id){
                    this.localModel.name = 'Nova Junção';
                    this.localModel.dynamic_join_status_id = 1;
                    this.localModel.only_grid_not_join = 1;
                    this.localModel.limit_classroom = 60;
                    this.localModel.limit_practice = 30;
                    this.localModel.limit_digital = 120;
                    this.localModel.join_type = 'group';
                }
            }
        },

        model(val) {
            this.localModel = Object.assign({}, this.model);
        },

        localModel(newVal) {
            this.$emit('update:model', newVal);
        }
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-puzzle-outline"
        },
        title: {
            type: String,
            default: "Junção Dinâmica"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('dynamicGeneration', ['ActionUpdateDynamicJoin', 'ActionCreateDynamicJoin']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            let payload = {};
            Object.assign(payload, this.model);

            if(payload.campuses && payload.campuses.length > 0){
                payload.campuses = payload.campuses.map(c => ({ id: c.id }));
            }

             if(payload.courses && payload.courses.length > 0){
                payload.courses = payload.courses.map(c => ({ id: c.id }));
            }

            if(edit) {
                this.ActionUpdateDynamicJoin(payload)
                .then((res) => {
                    this.message = res.message ? res.message : '';
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message ? error.message : '';
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateDynamicJoin(payload)
                .then((res) => {
                     this.message = res.message ? res.message : '';
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message ? error.message : '';
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>